import React, { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { DropdownList, DropdownItem } from 'next-common-lib';
import i18n from 'i18n';
import { isIE } from 'utils/common';
import * as employeeActions from 'redux/ducks/Employee/EmployeeDucks';

export const DropDownTelCode = ({ name, initValue, disabled, selectCallBack }) => {
  const dispatch = useDispatch();
  const [nationTelCodeValue] = useWatch({
    name: ['nationTelCodeValue'],
  });
  const [selectCode, setSelectCode] = useState();
  const { setValue, getValues } = useFormContext();
  const telCodeList = useSelector(state => state.employee.telCodeList);

  const makeRsrcKeyVal = _rsrcKeyVal => {
    const rsrcKeyValList = _rsrcKeyVal.split('|');
    if (rsrcKeyValList.length === 1) {
      return i18n.t(rsrcKeyValList[0]);
    }
    let rsrcKeyValString = '';
    rsrcKeyValList.map((val, index) => {
      rsrcKeyValString += i18n.t(val);
      if (rsrcKeyValList.length - 1 !== index) {
        rsrcKeyValString += ' / ';
      }
    });

    return rsrcKeyValString;
  };

  useEffect(() => {
    telCodeList?.map((item, index) => {
      if (item.rsrcCdVal === initValue) {
        setSelectCode(`${makeRsrcKeyVal(item.rsrcKeyVal)} ${item.rsrcCdVal}`);
        setValue(name, item.rsrcCdVal);
      }
    });
  }, [initValue]);
  useEffect(() => {
    if (telCodeList.length === 0) dispatch(employeeActions.getNationTelCodeList());
  }, []);

  useEffect(() => {
    if (telCodeList.length > 0) {
      const telCodeListValue = telCodeList.find(value => value.rsrcCdVal === nationTelCodeValue);
      if (telCodeListValue) {
        setSelectCode(`${i18n.t(telCodeListValue.rsrcKeyVal)} ${telCodeListValue.rsrcCdVal}`);
        setValue(name, telCodeListValue.rsrcCdVal);
      }
    }
  }, [nationTelCodeValue]);

  useEffect(() => {
    if (telCodeList.length > 0) {
      setSelectCode(`${i18n.t(telCodeList[0].rsrcKeyVal)} ${telCodeList[0].rsrcCdVal}`);
      setValue(name, telCodeList[0].rsrcCdVal);
    }
  }, [telCodeList]);

  return (
    <>
      {isIE() ? (
        <select
          className="ie-dropdown"
          onChange={e => {
            setValue(name, e.target.value);
          }}
          disabled={disabled}
        >
          {telCodeList?.map((item, index) => {
            return (
              <option value={item.rsrcCdVal} key={item.rsrcCdVal}>{`${makeRsrcKeyVal(item.rsrcKeyVal)} ${
                item.rsrcCdVal
              }`}</option>
            );
          })}
        </select>
      ) : (
        <DropdownList
          componentType="searchbox"
          label={selectCode}
          breakNum={5}
          disable={disabled}
          value={getValues(name)}
        >
          {telCodeList?.map((item, index) => {
            return (
              <DropdownItem
                key={item.rsrcCdVal}
                value={item.rsrcCdVal}
                name={`${makeRsrcKeyVal(item.rsrcKeyVal)} ${item.rsrcCdVal}`}
                onClick={e => {
                  setSelectCode(e.name);
                  setValue(name, e.value);
                  selectCallBack();
                }}
              />
            );
          })}
        </DropdownList>
      )}
    </>
  );
};

DropDownTelCode.propTypes = {
  name: PropTypes.string,
  initValue: PropTypes.string,
  disabled: PropTypes.bool,
  selectCallBack: PropTypes.func.isRequired,
};
DropDownTelCode.defaultProps = { name: null, initValue: '', disabled: false };

export default DropDownTelCode;
